import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasBackdrop = ({ open, onClick, onClose, children, className, sx, ...props }) => {
  if (!open) return null
  return (
    <div
      className={cn('fixed inset-0 z-40 bg-black/50 flex items-center justify-center', className)}
      onClick={onClick || onClose}
      {...props}
    >
      {children}
    </div>
  )
}

AdasBackdrop.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  sx: PropTypes.object
}
